module.exports = __webpack_public_path__ + "static/media/talent.b37f1b02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/estrategas/tools/talent.svg
// module id = 608
// module chunks = 0